import { Grid, Typography, Divider, TextField } from "@mui/material";

/**
 * Creates a section header component with title and divider
 * @param {Object} props - Component props
 * @param {string} props.title - Title of the section
 * @param {Function} props.t - Translation function
 * @returns {JSX.Element} Section header component
 */
export const SectionHeader = ({ title, t }) => (
  <Grid item xs={12}>
    <Typography
      variant="h6"
      color="primary"
      gutterBottom
      sx={{ fontWeight: 600, mt: title === "Request Details" ? 2 : 0 }}
    >
      {t(title)}
    </Typography>
    <Divider sx={{ mb: 2 }} />
  </Grid>
);

export const initialBiocharFormData = {
  name: "",
  farm_id: "",
  organization: "",
  email: "",
  phone_number: "",
  district: "",
  village: "",
  state: "",
  pincode: "",
  postoffice: "",
  addressLine1: "",
  quantity_required: "",
  preferred_mode_of_delivery: "SELFPICKUP",
  address_line1: "",
};

export const requestDetailFields = [
  {
    name: "quantity_required",
    label: "Quantity Required (in metric tons)",
    required: true,
    type: "number",
    sm: 12,
  },
];

/**
 * Prepare submission data based on authentication status
 * @param {Object} formData - Form data
 * @param {boolean} isUserAuthenticated - Authentication status
 * @returns {Object} Formatted submission data
 */
export const prepareBiocharSubmissionData = (formData, isUserAuthenticated) => {
  const submissionData = {
    name: formData.name,
    email: formData.email,
    phone_number: formData.phone_number,
    pincode: formData.pincode,
    state: formData.state,
    district: formData.district,
    postoffice: formData.postoffice,
    village: formData.village,
    address_line1: formData.address_line1,
    quantity_required: formData.quantity_required,
    preferred_mode_of_delivery: formData.preferred_mode_of_delivery,
  };

  if (isUserAuthenticated) {
    if (formData.farm_id) {
      submissionData.farm_id = formData.farm_id;
    }
  } else {
    submissionData.organization = formData.organization;
  }

  return submissionData;
};

/**
 * Renders form fields based on configuration
 * @param {Array} fields - Array of field configuration objects
 * @param {Object} formData - Current form data
 * @param {Object} errors - Form validation errors
 * @param {Function} handleChange - Change handler function
 * @param {Function} t - Translation function
 * @returns {Array} Array of rendered field components
 */
export const renderFormFields = (fields, formData, errors, handleChange, t) => {
  return fields.map((field) => (
    <Grid item xs={12} sm={field.sm} key={field.name}>
      <TextField
        required={field.required}
        fullWidth
        label={t(field.label)}
        name={field.name}
        type={field.type}
        value={formData[field.name]}
        onChange={(e) => {
          handleChange(e.target.name, e.target.value);
        }}
        variant="outlined"
        error={Boolean(errors[field.name])}
        helperText={errors[field.name] || ""}
        inputProps={field.maxLength ? { maxLength: field.maxLength } : {}}
      />
    </Grid>
  ));
};
